const pluginName = 'grassrootz';

const defaults = {
  charities: null,
  charitiesGroupedByRegistrantIndex: null,
  routes: {
    donationAcceptanceVerification: '',
  },
  templates: {
    charityAdd: '',
    charities: '',
    charityBox: '',
    charityCollapsed: '',
  },
  i18n: {
    noSearchRecords: '',
    defaultError: '',
  },
};

const selectors = {
  container: '.js-registrant-grassrootz-charity',
  addCharity: '.js-grassrootz-charity-add',
  editCharity: '.js-grassrootz-charity-edit',
  confirmCharity: '.js-grassrootz-charity-confirm-selection',
  removeCharity: '.js-grassrootz-charity-remove',
  charityGroup: '[data-js-charity-group]',
  charityBox: '[data-js-charity-box]',
  charitySelectionInput: '[data-js-charity-selection-input]',
  charitySelectionInputSpinner: '[data-js-charity-selection-input-spinner]',
  addCharityContainer: '.js-add-grassrootz-charity-section',
  charityContainer: '[data-js-grassrootz-charity-section]',
  charitySearchInput: '.js-grassrootz-charity-search-input',
  charitySearchResults: '[data-js-grassrootz-charity-search-results]',
  collapsedCharityContainer: '.js-collapsed-grassrootz-charity-container',
  collapsedCharityImage: '.js-collapsed-grassrootz-charity-image',
  collapsedCharityName: '.js-collapsed-grassrootz-charity-name',
  collapsedCharityCampaignIdInput: '.js-collapsed-grassrootz-charity-campaign-id-input',
  contributionPreferenceFieldset: '[data-js-contribution-preference-fieldset]',
  contributionPreferenceSpinner: '[data-js-contribution-preference-spinner]',
  contributionPreference: '[data-js-contribution-preference]',
  contributionPreferenceContainer: '[data-js-contribution-preference-container]',
  contributionPreferenceContainerDonate: '[data-js-contribution-preference-container-donate]',
  consentContainer: '[data-js-consent-container]',
  consentContentPage: '[data-js-consent-content-page]',
  consentContentDonate: '[data-js-consent-content-donate]',
  groupFieldset: '[data-js-grassrootz-group-fieldset]',
};

const classes = {
  disabled: 'disabled',
  hidden: 'hidden',
  search: 'fa-search',
  spinner: 'fa-spinner fa-pulse',
  charityInactive: 'grassrootz-charity-container--inactive',
  charitySelected: 'grassrootz-charity-container--complete',
};

const getElements = ($element) => ({
  $element,
  $submit: $element.find('[type="submit"]'),
  $snackBar: $('[data-js-snack-bar]'),
});

/**
 * Remove the disabled states
 */
const enableButtonActions = (data) => {
  data.elements.$element.find(selectors.container).removeClass(classes.charityInactive);
  data.elements.$element.find(selectors.editCharity).removeClass(classes.disabled);
  data.elements.$element.find(selectors.addCharity).removeClass(classes.disabled);
  data.elements.$element.find(selectors.removeCharity).removeClass(classes.disabled);
  data.elements.$submit.removeClass(classes.disabled);
};

/**
 * Expand the charity selection form of a registrant
 *
 * @param data
 * @param registrantIndex
 */
const expandCharity = (data, registrantIndex) => {
  const $charityContainer = data.elements.$element
    .find(selectors.charityContainer)
    .filter(`[data-registrant-index="${registrantIndex}"]`);
  const $container = $charityContainer.closest(selectors.container);
  const $collapseContainer = $container.find(selectors.collapsedCharityContainer);

  // Ghost the other containers
  data.elements.$element.find(selectors.container).addClass(classes.charityInactive);
  $container.find(selectors.editCharity).addClass(classes.hidden);
  $charityContainer.removeClass(classes.hidden);
  $collapseContainer.addClass(classes.hidden);

  // Remove that coloring
  $container.removeClass(`${classes.charitySelected} ${classes.charityInactive}`);
  $container.find('.panel-heading').find(selectors.removeCharity).removeClass(classes.hidden);

  // Enable actions
  $container.find(selectors.editCharity).removeClass(classes.disabled);
  $container.find(selectors.addCharity).removeClass(classes.disabled);
  $container.find(selectors.removeCharity).removeClass(classes.disabled);
};

/**
 * Add a charity for a registrant
 *
 * @param data
 * @param $addButton
 */
const addCharity = (data, $addButton) => {
  const $container = $addButton.closest(selectors.container);
  const registrantIndex = $addButton.data('registrant-index');
  const availableCharities = data.settings.charitiesGroupedByRegistrantIndex[registrantIndex];
  const $template = $(data.settings.templates.charities.replace(/__INDEX__/g, registrantIndex));

  // if a charity isn't in the available charities for the registrant, remove its box
  $template
    .find(selectors.charityBox)
    .each((index, charityBox) => {
      const $charityBox = $(charityBox);
      const campaignId = parseInt($charityBox.attr('data-campaign-id'), 10);

      if (!availableCharities.some((charity) => charity.campaignId === campaignId)) {
        $charityBox.remove();
      }
    });

  // if a charity group no longer has any charity boxes in it due to the above removals, remove it
  $template
    .find(selectors.charityGroup)
    .each((index, charityGroup) => {
      const $charityGroup = $(charityGroup);

      if (!$charityGroup.find(selectors.charityBox).length) {
        $charityGroup.remove();
      }
    });

  const $containerBody = $container.find('.panel-body');

  $containerBody.find(selectors.addCharityContainer).remove();
  $containerBody.prepend($template);

  // Disable buttons - only when there is more than one donation possible
  if (data.elements.$element.find(selectors.container).length > 1) {
    data.elements.$submit.addClass(classes.disabled);
    data.elements.$element.find(selectors.editCharity).addClass(classes.disabled);
    data.elements.$element.find(selectors.addCharity).addClass(classes.disabled);
    data.elements.$element.find(selectors.removeCharity).addClass(classes.disabled);
  }

  // Display the charity selection form
  expandCharity(data, registrantIndex);
};

/**
 * Remove the charity selection of a registrant
 *
 * @param data
 * @param event
 */
const removeCharity = (data, event) => {
  const $this = $(event.currentTarget);
  const $container = $this.closest(selectors.container);
  const registrantIndex = $this.data('registrant-index');
  const $containerBody = $container.find('.panel-body');

  // Remove the donation
  $containerBody.find(selectors.collapsedCharityContainer).remove();
  $containerBody.find(selectors.charityContainer).remove();
  $container.find(selectors.editCharity).addClass(classes.hidden);
  $container.find('.panel-heading').find(selectors.removeCharity).addClass(classes.hidden);
  $container.removeClass(classes.charitySelected);

  // Add an add button
  const $template = $(data.settings.templates.charityAdd.replace(/__INDEX__/g, registrantIndex));
  $containerBody.prepend($template);

  enableButtonActions(data);
};

/**
 * Search the charities
 * @param data
 * @param $input
 */
const search = (data, $input) => {
  const $charityContainer = $input.closest(selectors.charityContainer);
  const $searchResultsContainer = $charityContainer.find(selectors.charitySearchResults);
  const searchTerm = $input.val().trim().toLowerCase();

  if (!searchTerm) {
    $searchResultsContainer.addClass(classes.hidden);
    return;
  }

  const results = data.charities.filter((charity) => charity.name.toLowerCase().includes(searchTerm));

  if (!results.length) {
    $searchResultsContainer.addClass(classes.hidden);
    data.elements.$snackBar.snackBar('add', {
      type: 'warning',
      icon: 'exclamation-triangle',
      content: data.settings.i18n.noSearchRecords,
      autoClose: 5000,
    });
    return;
  }

  const registrantIndex = $charityContainer.data('registrant-index');

  const template = results.reduce((accumulator, charity) => {
    const resultTemplate = data.settings.templates.charityBox
      .replace(/__INDEX__/g, registrantIndex)
      .replace(/__CHARITY_IMAGE_URL__/g, charity.imageUrl)
      .replace(/__CHARITY_NAME__/g, charity.name)
      .replace(/__CHARITY_CAMPAIGN_ID__/g, charity.campaignId);

    return `${accumulator}${resultTemplate}`;
  }, '');

  $searchResultsContainer
    .html(template)
    .removeClass(classes.hidden);
};

/**
 * Ask the server whether the selected charity can accept donations
 * @param data
 * @param charityId
 * @returns {JQuery.jqXHR}
 */
const getCanAcceptDonation = (data, charityId) => $.ajax({
  url: data.settings.routes.donationAcceptanceVerification,
  data: {
    campaign_id: charityId,
  },
});

/**
 * Update the contribution choices (show/hide) based on whether the selected charity can accept
 * donations, then check and trigger change if there is only 1 visible
 * @param data
 * @param canAcceptDonations
 */
const updateContributionPreferences = (data, canAcceptDonations) => {
  data.elements.$element
    .find(selectors.contributionPreferenceContainerDonate)
    .toggleClass(classes.hidden, !canAcceptDonations);

  const $visiblecontributionPreferences = data.elements.$element
    .find(selectors.contributionPreference)
    .filter(':visible');

  if ($visiblecontributionPreferences.length === 1) {
    $visiblecontributionPreferences
      .prop('checked', true)
      .trigger('change');
  }
};

/**
 * Action taken when a charity selection has been selected
 *
 * @param data
 * @param $charityInput
 */
const selectCharity = (data, $charityInput) => {
  const charityId = $charityInput.val();
  const $fieldset = $charityInput.closest(selectors.groupFieldset);
  const $spinner = $charityInput
    .closest(selectors.charityBox)
    .find(selectors.charitySelectionInputSpinner);

  $fieldset.prop('disabled', true);
  $spinner.removeClass(classes.hidden);

  getCanAcceptDonation(data, charityId)
    .always(() => {
      $fieldset.prop('disabled', false);
      $spinner.addClass(classes.hidden);
    })
    .done((response) => {
      const $charityContainer = $charityInput.closest(selectors.charityContainer);
      const $container = $charityContainer.closest(selectors.container);
      const $containerBody = $container.find('.panel-body');
      const registrantIndex = $charityContainer.data('registrant-index');
      const charity = {
        ...data.charities.find((charitySearch) => charitySearch.campaignId === parseInt(charityId, 10)),
        canAcceptDonations: response.canAcceptDonations,
      };

      $container.find('.panel-heading').find(selectors.removeCharity).addClass(classes.hidden);
      $container.addClass(classes.charitySelected);
      $containerBody.find(selectors.charityContainer).remove();

      const $collapsedContainer = $(data.settings.templates.charityCollapsed.replace(/__INDEX__/g, registrantIndex));

      $collapsedContainer.find(selectors.collapsedCharityImage).attr('src', charity.imageUrl);
      $collapsedContainer.find(selectors.collapsedCharityName).text(charity.name);
      $collapsedContainer.find(selectors.collapsedCharityCampaignIdInput).val(charityId);

      $container.find('.panel-body').prepend($collapsedContainer);

      updateContributionPreferences(data, charity.canAcceptDonations);

      enableButtonActions(data);
    })
    .fail(() => {
      $charityInput.prop('selected', false);
      data.elements.$snackBar.snackBar('add', {
        type: 'warning',
        icon: 'exclamation-triangle',
        content: data.settings.i18n.defaultError,
        autoClose: 5000,
      });
    });
};

/**
 * Update the consent content based on which contribution preference was selected
 * @param $contributionPreference
 */
const updateConsentContent = ($contributionPreference) => {
  const contributionPreference = $contributionPreference.val();
  const $charityContainer = $contributionPreference.closest(selectors.collapsedCharityContainer);

  if (contributionPreference === 'donation') {
    $charityContainer.find(selectors.consentContentDonate).removeClass(classes.hidden);
    $charityContainer.find(selectors.consentContentPage).addClass(classes.hidden);
  } else {
    $charityContainer.find(selectors.consentContentDonate).addClass(classes.hidden);
    $charityContainer.find(selectors.consentContentPage).removeClass(classes.hidden);
  }

  $charityContainer.find(selectors.consentContainer).removeClass(classes.hidden);
};

/**
 * If the user navigates back to this step using the back button or breadcrumbs, or even just
 * refreshes, we need to ask the server again whether the selected charity accepts donations
 */
const updateSelectedCharity = (data) => {
  const charityId = data.elements.$element.find(selectors.collapsedCharityCampaignIdInput).val();

  if (!charityId) {
    return;
  }

  const $spinner = data.elements.$element.find(selectors.contributionPreferenceSpinner);
  const $fieldset = data.elements.$element.find(selectors.contributionPreferenceFieldset);

  $fieldset.prop('disabled', true);
  $spinner.removeClass(classes.hidden);

  getCanAcceptDonation(data, charityId)
    .done((response) => {
      updateContributionPreferences(data, response.canAcceptDonations);
      $fieldset.prop('disabled', false);
      $spinner.addClass(classes.hidden);
    })
    .fail(() => {
      data.elements.$snackBar.snackBar('add', {
        type: 'warning',
        icon: 'exclamation-triangle',
        content: data.settings.i18n.defaultError,
      });
    });
};

/**
 * Initialize listeners and properties
 */
const initialize = ($element, options) => {
  if ($element.data(pluginName)) {
    return;
  }

  const elements = getElements($element);

  const settings = $.extend(true, {}, $.fn[pluginName].DEFAULTS, options);

  const data = {
    elements,
    settings,
    charities: Object.keys(settings.charities).map((key) => settings.charities[key]),
  };

  data.elements.$element.on('click', selectors.addCharity, (event) => {
    addCharity(data, $(event.currentTarget));
  });
  data.elements.$element.on('click', selectors.removeCharity, (event) => {
    removeCharity(data, event);
  });
  data.elements.$element.on('change', selectors.charitySelectionInput, (event) => {
    selectCharity(data, $(event.currentTarget));
  });
  data.elements.$element.on('change', selectors.contributionPreference, (event) => {
    updateConsentContent($(event.currentTarget));
  });
  data.elements.$element.on('keyup', selectors.charitySearchInput, (event) => {
    search(data, $(event.currentTarget));
  });

  data.elements.$element.trigger('raceRoster.preventDoubleSubmission.reEnable');

  updateSelectedCharity(data);

  $(window).on('pageshow', (event) => {
    // there's a chrome bug around the persisted property so we check window.performance too
    if (event.originalEvent.persisted || (window.performance && window.performance.navigation.type === 2)) {
      updateSelectedCharity(data);
    }
  });
};

/**
 *
 * @param options
 * @returns jQuery
 */
const plugin = function plugin(options) {
  return this.each((index, element) => initialize($(element), options));
};

plugin.DEFAULTS = defaults;

$(() => {
  if (pluginName in $.fn) {
    return;
  }

  $.extend($.fn, {
    [pluginName]: plugin,
  });
});
